export const BASE_URL = "http://104.198.221.136:8080";
export const SMS_SUCCESS = "Success"